import React, { Component }       from 'react';
import EmployeeBenefitsService    from 'services/employee-benefits.service';
import AuthService                from 'services/auth.service';
import queryString                from 'query-string';

export class EmployeeBenefitsWeeklyStats extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stats: {
        total_registration: 0,
        total_claims: 0,
        cancelled_appointments: 0,
        skipped_appointments: 0,
        pending_claims_approval: 0
      }
    };
  }

  reloadStats(props) {
    const parameters = queryString.stringify({
      start_date: this.props.start_date,
      end_date: this.props.end_date,
    });

    EmployeeBenefitsService.statistics(parameters).then(
      (data) => {
        const stats = {
          total_registration: data.total_registration,
          total_claims: data.total_claims,
          cancelled_appointments: data.cancelled_appointments,
          skipped_appointments: data.skipped_appointments,
          pending_claims_approval: data.pending_claims_approval
        }

        this.setState({
          stats: stats,
        });
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    );
  };

  componentDidMount() {
    this.reloadStats();
  }

  render() {
    return (
      <div className="statistics-overflow my-6 font-size-3">
        <div className="dashboard-stats-box text-center shadow-sm mr-2 mb-2" style={{ backgroundColor: "#FEF4E6" }}>
          <p className="text-grey fweight-500 font-size-20 pt-3 mb-2">{ this.state.stats.total_registration }</p>
          <h5 className="pb-6">Total<br/>Registrations</h5>
        </div>

        <div className="dashboard-stats-box text-center shadow-sm mr-2 mb-2" style={{ backgroundColor: "#F6FDF6" }}>
          <p className="text-grey fweight-500 font-size-20 pt-3 mb-2">{ this.state.stats.total_claims }</p>
          <h5 className="pb-6">Total<br/>Claims</h5>
        </div>

        <div className="dashboard-stats-box text-center shadow-sm mr-2 mb-2" style={{ backgroundColor: "#F3F6FF" }}>
          <p className="text-grey fweight-500 font-size-20 pt-3 mb-2">{ this.state.stats.cancelled_appointments }</p>
          <h5 className="pb-6">Cancelled<br/>Appointments</h5>
        </div>

        <div className="dashboard-stats-box text-center shadow-sm mr-2 mb-2" style={{ backgroundColor: "#FEF0F5" }}>
          <p className="text-grey fweight-500 font-size-20 pt-3 mb-2">{ this.state.stats.skipped_appointments }</p>
          <h5 className="pb-6">Skipped<br/>Appointments</h5>
        </div>

        <div className="dashboard-stats-box text-center shadow-sm mr-2 mb-2" style={{ backgroundColor: "#FFFDEB" }}>
          <p className="text-grey fweight-500 font-size-20 pt-3 mb-2">{ this.state.stats.pending_claims_approval }</p>
          <h5 className="pb-6">Pending Claims<br/>Approval</h5>
        </div>
      </div>
    )
  }
}